import { useState, useEffect } from 'react'
import fetch from 'node-fetch'
import { IFooterSectionLink } from '../src/library/elements/FooterSection'
import { IParsedLink } from 'marketing-site/pages/api/blog/autopilotCapsule'

export default function useFetchAutopilotNewsUpdates(): IFooterSectionLink[] {
  const [links, setLinks] = useState<IFooterSectionLink[]>([])
  useEffect(() => {
    const fetchPosts = async () => {
      await fetch('/api/blog/autopilotCapsule')
        .then((res) => res.json())
        .then((json: IParsedLink[]) => {
          setLinks(
            json.map((link: IParsedLink) => ({
              text: link.text,
              url: link.url,
            })),
          )
        })
    }
    fetchPosts()
  }, [])
  return links
}
